module.exports = __webpack_public_path__ + "static/media/01-thumbnail.eda45981.jpg";